// import "../CSS/Layout.css";
// import "../CSS/Footer.css";

// import React, { useContext, useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Box, Link, Typography, useMediaQuery } from "@mui/material";
// import { GlobalContext } from "../utils/GlobalContext";

// export default function Footer() {
//   let redirectPath = useNavigate();
//   const { isMobile } = useContext(GlobalContext);

//   return (
//     <Box className="footer-section">
//       <Box className="foot-content">
//         {/* Collaboration Text */}
//         <Box className="foot-text-container">
//           <a href="https://bac.umd.edu" target="_blank" rel="noopener noreferrer">
//             <Box className="bac-logo" component="img" src="/bacLogo.png" />
//           </a>
//           <Typography className="foot-text foot-text-left" mt="32px" ml="55px">
//             In collaboration with Federal Highway Administration to empower
//             public and private organizations to deliver crucial transportation
//             infrastructure projects using innovative financing and alternative
//             delivery methods
//           </Typography>
//         </Box>

//         {/* Disclaimer Box */}
//         <Box className="fhwa-disclaimer-box">
//           <Typography className="foot-text">
//             This website is based upon work supported by the Federal Highway Administration under Agreement No. - 693JJ32250002.
//             <br /><br />
//             Any opinions, findings, and conclusions or recommendations expressed in this website are those of the Author(s) and do not necessarily reflect the view of the Federal Highway Administration.
//             <br /><br />
//             See{" "}
//             <a
//               href="https://www.fhwa.dot.gov/cfo/contractor_recip/gtandc_generaltermsconditions.cfm"
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "white", textDecoration: "underline" }}
//             >
//               Contractors & Recipients General Terms and Conditions for Assistance Awards | Federal Highway Administration
//             </a>
//           </Typography>
//         </Box>

//          {/* Links */}
//         {!isMobile && (
//           <Box className="page-links">
//             <Link href="/nofo" underline="hover" color="white" fontSize={14}>
//               Funding Opportunities
//             </Link>
//             <Link href="/planahead" underline="hover" color="white" fontSize={14}>
//               Plan Ahead
//             </Link>
//             <Link href="/successfulawards" underline="hover" color="white" fontSize={14}>
//               Successful Awards
//             </Link>
//             <Link href="/boardmessages" underline="hover" color="white" fontSize={14}>
//               Community Forum
//             </Link>
//             <Link href="/gethelp" underline="hover" color="white" fontSize={14}>
//               Get Help
//             </Link>
//             <Link href="/disclaimer" underline="hover" color="white" fontSize={14}>
//               Disclaimer
//             </Link>
//           </Box>
//         )}

//        {/* Social and Copyright */}
//         <Box className="flex-column">
//           <Typography fontSize={13} mb="30px" mt="2px" textAlign="center">
//             A Product of the Build America Center
//           </Typography>
//           <Box className="flex-row" sx={{ gap: "30px" }}>
//             <a
//               href="https://www.linkedin.com/company/build-america-center/?viewAsMember=true"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Box className="external-logo" component="img" src="/linkedin.png" />
//             </a>
//             <a
//               href="https://www.youtube.com/channel/UC9BsbWS-SxrDYgBN0qFM-tg/about"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Box className="external-logo" component="img" src="/youtube.png" />
//             </a>
//           </Box>
//           <Typography fontSize={13} mt="30px" textAlign="center">
//             © 2022-2022 Build America Center. All Rights Reserved.
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// }


import "../CSS/Footer.css";

import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import { GlobalContext } from "../utils/GlobalContext";

export default function Footer() {
  let redirectPath = useNavigate();
  const { isMobile } = useContext(GlobalContext);

  return (
    <Box className="footer-section">
      <Box className="footer-content">
        {/* Collaboration Text */}
        <Box className="footer-text-container">
          <a href="https://bac.umd.edu" target="_blank" rel="noopener noreferrer">
            <Box className="footer-bac-logo" component="img" src="/bacLogo.png" />
          </a>
          <Typography className="footer-text footer-text-left" mt="32px" ml="55px">
            In collaboration with Federal Highway Administration to empower
            public and private organizations to deliver crucial transportation
            infrastructure projects using innovative financing and alternative
            delivery methods
          </Typography>
        </Box>

        {/* Disclaimer Box */}
        <Box className="footer-fhwa-disclaimer-box">
          <Typography className="footer-text">
            This website is based upon work supported by the Federal Highway Administration under Agreement No. - 693JJ32250002.
            <br /><br />
            Any opinions, findings, and conclusions or recommendations expressed in this website are those of the Author(s) and do not necessarily reflect the view of the Federal Highway Administration.
            <br /><br />
            See{" "}
            <a
              href="https://www.fhwa.dot.gov/cfo/contractor_recip/gtandc_generaltermsconditions.cfm"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white", textDecoration: "underline" }}
            >
              Contractors & Recipients General Terms and Conditions for Assistance Awards | Federal Highway Administration
            </a>
          </Typography>
        </Box>

        {/* Links */}
        {!isMobile && (
          <Box className="footer-page-links">
            <Link href="/nofo" underline="hover" color="white" fontSize={14}>
              Funding Opportunities
            </Link>
            <Link href="/planahead" underline="hover" color="white" fontSize={14}>
              Plan Ahead
            </Link>
            <Link href="/successfulawards" underline="hover" color="white" fontSize={14}>
              Successful Awards
            </Link>
            <Link href="/boardmessages" underline="hover" color="white" fontSize={14}>
              Community Forum
            </Link>
            <Link href="/gethelp" underline="hover" color="white" fontSize={14}>
              Get Help
            </Link>
            <Link href="/disclaimer" underline="hover" color="white" fontSize={14}>
              Disclaimer
            </Link>
          </Box>
        )}

        {/* Social and Copyright */}
        <Box className="footer-flex-column">
          <Typography fontSize={13} mb="30px" mt="2px" textAlign="center">
            A Product of the Build America Center
          </Typography>
          <Box className="footer-flex-row" sx={{ gap: "30px" }}>
            <a
              href="https://www.linkedin.com/company/build-america-center/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box className="footer-external-logo" component="img" src="/linkedin.png" />
            </a>
            <a
              href="https://www.youtube.com/channel/UC9BsbWS-SxrDYgBN0qFM-tg/about"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box className="footer-external-logo" component="img" src="/youtube.png" />
            </a>
          </Box>
          <Typography fontSize={13} mt="30px" textAlign="center">
            © 2022-2022 Build America Center. All Rights Reserved.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}